/**
 * Core gamification constants (plan P0 config lock).
 */

export const DAILY_ACTION_EXP_CAP = 200;

/** Leaderboard IMMEDIATE in-tx vs BATCH job threshold. */
export const LEADERBOARD_SYNC_PARTICIPANT_THRESHOLD = 200;

/** Monster card drop chance on eligible encounter loot (D38 / per-bubble P11). */
export const MONSTER_CARD_DROP_RATE = 0.02;

/** Shiny roll after enemy type chosen (D38). */
export const SHINY_ENCOUNTER_RATE = 0.001;

/** Victory gold multiplier when EnemyInstance.isShiny. */
export const SHINY_GOLD_MULTIPLIER = 2;
